import React, { useEffect, useRef, useState } from 'react'
import '../videos.css'
import VideoDetails from './VideoDetails'
import AtenyaAi from './AtenyaAi'
import SentimentScore from './SentimentScore'
import VEmotionsScore from './VEmotionsScore'
import Comments from './Comments'
import VideoLineChart from './VideoLineChart'
import { useDispatch, useSelector } from 'react-redux'
import { CommentBgImage, DataNotFoundImage } from 'assets'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import {
   getVideoDetailsByIdAction,
   resetIsBackToVideo,
   setAllVideoDataAction,
   setVideoRiskScore
} from 'store/action/videoReducer'
import { videStatusConst } from 'constant/const'

function VideoAnalysis() {
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData
   const videoRedux = useSelector((state) => state.videoRedux)
   const { videoDetailsLoader, videoDetails, commentList, isBackToVideo, allVideoData,videoRiskScore } = videoRedux
   const params = useParams()
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const location = useLocation()

   useEffect(() => {
      if (isBackToVideo) {
         if (allVideoData && allVideoData?.length > 0) {
            let result = allVideoData.map((video) =>
               video.video_id === params?.id
                  ? {
                       ...video,
                       status: videStatusConst.processing
                    }
                  : video
            )
            // console.log('aa', result, allVideoData)
            dispatch(setAllVideoDataAction(result))
         }
         dispatch(resetIsBackToVideo())
         navigate(`/videos${location?.search}`)
      }
      return () => {
         dispatch(resetIsBackToVideo())
      }
   }, [isBackToVideo, allVideoData])

   // find top
   function findTopEmotionByType(positive = [], negative = [], neutral = []) {
      // Combine and tag each emotion with its category
      const combined = [
         ...positive.map((item) => ({ ...item, emotion: 'positive' })),
         ...negative.map((item) => ({ ...item, emotion: 'negative' })),
         ...neutral.map((item) => ({ ...item, emotion: 'neutral' }))
      ]

      // Return null if no data
      if (combined.length === 0) {
         return null
      }

      // Find the emotion with the highest count
      const top = combined.reduce((max, item) => {
         return item.count > max.count ? item : max
      })

      // Return top emotion details
      return {
         type: top.text,
         count: top.count,
         emotion: top.emotion
      }
   }

   // update all video list for casing
   useEffect(() => {
      if (videoDetails && videoDetails?.video_id && allVideoData && allVideoData?.length > 0) {
         let top_emotion = findTopEmotionByType(
            videoDetails?.top_positive_comments || [],
            videoDetails?.top_negative_comments || [],
            videoDetails?.top_neutral_comments || []
         )
         console.log('first', top_emotion)
         let result = allVideoData.map((video) =>
            video.video_id === videoDetails?.video_id
               ? {
                    ...video,
                    is_analyzed: videoDetails?.is_analyzed,
                    top_emotion: {
                       count: top_emotion?.count,
                       emotion: top_emotion?.type,
                       top_sentiment: top_emotion?.emotion,
                       top_sentiment_percentage: ''
                    },
                    total_analyzed_comments: videoDetails?.total_analyzed_comments,
                    status: videoDetails?.status,
                    sentiment_score: videoDetails?.sentiment_score,
                    risk_score: videoRiskScore || videoDetails?.risk_score,
                    comment_count: videoDetails?.comment_count
                 }
               : video
         )
         // console.log('aa', result, allVideoData)
         dispatch(setAllVideoDataAction(result))
      }
      return () => {}
   }, [videoDetails, videoRiskScore])

   useEffect(() => {
      if (params?.id && selectedChannelID) {
         console.log('location', location)
         if (location.state?.type === 'full') {
            dispatch(
               getVideoDetailsByIdAction({
                  channel_id: selectedChannelID,
                  video_id: params?.id,
                  analyze: location.state?.type
               })
            )
         } else {
            dispatch(
               getVideoDetailsByIdAction({
                  channel_id: selectedChannelID,
                  video_id: params?.id,
                  analyze: location.state?.type
               })
            )
         }
      }
      return () => {
         dispatch(setVideoRiskScore(null))
      }
   }, [params, location])

   return (
      <>
         <div className="d-flex gap-3 align-items-center justify-content-between flex-wrap view-report-btn ">
            <div className="at-text-light breadcrumb-menu">
               <Link to={`/dashboard${location?.search}`}>Dashboard</Link> /{' '}
               <Link to={`/videos${location?.search}`}>Videos</Link> /{' '}
               <span title={videoDetails?.title}>
                  {videoDetails?.title?.length > 50
                     ? `${videoDetails?.title.slice(0, 50)}...`
                     : videoDetails?.title}
               </span>
            </div>
            <Link
               to={`/videos/analysis/report/${videoDetails?.video_id}${location?.search}`}
               target="_blank">
               <button className="btn btn-primary my-3 rounded-5">View Report PDF</button>
            </Link>
         </div>
         <div className="video-analysis-section">
            {!videoDetailsLoader && !videoDetails?.video_id ? (
               <div className="not-found-section">
                  <img
                     src={DataNotFoundImage}
                     alt="DataNotFoundImageF"
                     className="not-found-image"
                  />
                  <p>Oops!, Video details not found </p>
                  <div
                     className="load-more mt-4"
                     onClick={() => {
                        navigate(-1)
                     }}>
                     <div className="atenya-ai-btn">
                        <span>Back</span>
                     </div>
                  </div>
               </div>
            ) : (
               <>
                  <VideoDetails />
                  <div>
                     <div className="row mt-3">
                        <div className="col-12 col-lg-6 col-xl-4">
                           <SentimentScore />
                        </div>
                        <div className="col-12 col-lg-6 col-xl-8">
                           <VEmotionsScore />
                        </div>
                     </div>
                  </div>
                  <div className="mt-4">
                     <AtenyaAi />
                  </div>
                  {/* chart */}
                  <div className="mt-4 position-relative">
                     <VideoLineChart />
                  </div>
                  {commentList && (
                     <div className="mt-4 position-relative">
                        {/* <div className="comment-bg-image"></div> */}
                        <img
                           className="comment-bg-image"
                           src={CommentBgImage}
                           alt="CommentBgImage"
                        />
                        <Comments />
                     </div>
                  )}
               </>
            )}
         </div>
      </>
   )
}

export default VideoAnalysis
